import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { Router } from '@reach/router';

import { REWARD_CARD_PACKS } from './services/graphql';
import styles from './RewardCards.module.scss';

import Tabs from '../../components/Tabs';
import Tab from '../../components/Tab';

import { Loader } from '@squirrellearningltd/go-teacher-components';
import { useEffectOnce } from 'react-use';
import RewardCardsPack from './components/pack/reward-cards-pack/RewardCardsPack';
import RewardPacksList from './components/packs/reward-cards-pack-list/RewardCardsPackList';

const TABS = {
    published: 1,
    drafts: 2,
};

const RewardCards = () => {
    return <>
        <Router>
            <RewardCardsContent
                path='/'
                default
            />
            <RewardCardsPack
                path='/pack/:packId'
            />
        </Router>
    </>
}

const RewardCardsContent = () => {
    const [selectedTab, setSelectedTab] = useState(TABS.published);
    const [rewardCards, setRewardCards] = useState([]);

    const [loadRewardCardsPackPublished, { loading, error }] = useLazyQuery(REWARD_CARD_PACKS, {
        fetchPolicy: 'network-only', // Ensure the latest data is fetched from the server
        onCompleted: (data) => setRewardCards(data.rewardCardPacks)
    });

    const [loadRewardCardsPackDraft, { data: rewardCardPacksDraft, loading: rewardCardPacksDraftLoading, error: rewardCardPacksDraftError }] = useLazyQuery(REWARD_CARD_PACKS, {
        fetchPolicy: 'network-only',
        variables: {
            published: false
        },
        onCompleted: (data) => setRewardCards(data.rewardCardPacks)
    })

    useEffectOnce(() => loadRewardCardsPackPublished());

    if (error || rewardCardPacksDraftError) {
        return <p>{error ? error.message : rewardCardPacksDraftError.message}</p>
    }

    return (
        <>
            <div className={styles.Header}>
                <h2 className={styles.HeaderTitle}>Reward Cards</h2>
            </div>

            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedTab === TABS.published}
                    onClick={() => {
                        setRewardCards([]);
                        loadRewardCardsPackPublished();
                        setSelectedTab(TABS.published);
                    }}
                >
                    Published
                </Tab>
                <Tab
                    selected={selectedTab === TABS.drafts}
                    onClick={() => {
                        setRewardCards([]);
                        loadRewardCardsPackDraft();
                        setSelectedTab(TABS.drafts);
                    }}
                >
                    Drafts
                </Tab>
            </Tabs>

            {
                loading || rewardCardPacksDraftLoading ?
                    <Loader /> :
                    <RewardPacksList
                        rewardPacks={rewardCards}
                        onPackDeleted={
                            selectedTab === TABS.published
                                ? loadRewardCardsPackPublished
                                : loadRewardCardsPackDraft
                        }
                    />
            }
        </>
    )
}


export default RewardCards;